// Bildergalerie fuer Magazin-Artikel, 24.09.2026.
// Jedes Bild im Artikel, das in <a href="<grosses Bild>" data-galerie="<name>"> steckt, oeffnet
// beim Antippen eine Grossansicht. Bilder mit demselben Galerienamen lassen sich durchblaettern:
// Pfeile, Pfeiltasten oder Wischen. Ein Tipp auf das Bild zeigt es in voller Aufloesung zum
// Verschieben, damit man beim Mahlgrad die Koernung wirklich sieht. Ohne JavaScript oeffnet der
// Link einfach das grosse Bild.
(() => {
  const inhalt = document.querySelector('.article-template__content');
  if (!inhalt) return;
  const links = [...inhalt.querySelectorAll('a[data-galerie]')];
  if (!links.length) return;

  let dialog, buehne, bild, text, zaehler, gruppe = [], pos = 0, ausloeser = null, wischStart = null;

  const knopf = (klasse, label, zeichen) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = `magazin-galerie__knopf ${klasse}`;
    b.setAttribute('aria-label', label);
    b.textContent = zeichen;
    return b;
  };

  const bauen = () => {
    dialog = document.createElement('dialog');
    dialog.className = 'magazin-galerie';
    dialog.setAttribute('aria-label', 'Bildergalerie');
    buehne = document.createElement('div');
    buehne.className = 'magazin-galerie__buehne';
    bild = document.createElement('img');
    bild.className = 'magazin-galerie__bild';
    bild.decoding = 'async';
    buehne.append(bild);
    const fuss = document.createElement('div');
    fuss.className = 'magazin-galerie__fuss';
    text = document.createElement('p');
    text.className = 'magazin-galerie__text';
    zaehler = document.createElement('p');
    zaehler.className = 'magazin-galerie__zaehler';
    fuss.append(text, zaehler);
    const zurueck = knopf('magazin-galerie__zurueck', 'Vorheriges Bild', '‹');
    const weiter = knopf('magazin-galerie__weiter', 'Nächstes Bild', '›');
    const zu = knopf('magazin-galerie__zu', 'Schließen', '×');
    dialog.append(buehne, fuss, zurueck, weiter, zu);
    document.body.append(dialog);

    zurueck.addEventListener('click', () => zeigen(pos - 1));
    weiter.addEventListener('click', () => zeigen(pos + 1));
    zu.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('magazin-galerie-offen');
      if (ausloeser) ausloeser.focus();
    });
    // Klick neben das Bild schliesst, Klick aufs Bild schaltet die volle Aufloesung um.
    dialog.addEventListener('click', (e) => { if (e.target === dialog || e.target === buehne) dialog.close(); });
    bild.addEventListener('click', (e) => {
      const gross = !dialog.classList.contains('ist-gross');
      const r = bild.getBoundingClientRect();
      const fx = (e.clientX - r.left) / r.width;
      const fy = (e.clientY - r.top) / r.height;
      dialog.classList.toggle('ist-gross', gross);
      if (gross) {
        buehne.scrollLeft = fx * buehne.scrollWidth - buehne.clientWidth / 2;
        buehne.scrollTop = fy * buehne.scrollHeight - buehne.clientHeight / 2;
      }
    });
    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); zeigen(pos - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); zeigen(pos + 1); }
    });
    // Wischen nur in der normalen Ansicht, in der vollen Aufloesung verschiebt der Finger das Bild.
    buehne.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' && !dialog.classList.contains('ist-gross')) wischStart = { x: e.clientX, y: e.clientY };
    });
    buehne.addEventListener('pointerup', (e) => {
      if (!wischStart) return;
      const dx = e.clientX - wischStart.x;
      const dy = e.clientY - wischStart.y;
      wischStart = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) zeigen(pos + (dx < 0 ? 1 : -1));
    });
  };

  const vorladen = (i) => {
    const a = gruppe[(i + gruppe.length) % gruppe.length];
    if (a) { const v = new Image(); v.src = a.href; }
  };

  const zeigen = (i) => {
    pos = (i + gruppe.length) % gruppe.length;
    const a = gruppe[pos];
    const klein = a.querySelector('img');
    dialog.classList.remove('ist-gross');
    // Sofort das schon geladene kleine Bild zeigen, das grosse ersetzt es, sobald es da ist.
    bild.src = klein && klein.currentSrc ? klein.currentSrc : a.href;
    if (bild.src !== a.href) {
      const gross = new Image();
      gross.onload = () => { if (gruppe[pos] === a) bild.src = a.href; };
      gross.src = a.href;
    }
    bild.alt = klein ? klein.alt : '';
    const unterschrift = a.closest('figure') && a.closest('figure').querySelector('figcaption');
    text.textContent = a.dataset.titel || (unterschrift ? unterschrift.textContent : '');
    zaehler.textContent = gruppe.length > 1 ? `${pos + 1} / ${gruppe.length}` : '';
    dialog.classList.toggle('ist-einzeln', gruppe.length < 2);
    vorladen(pos + 1);
    vorladen(pos - 1);
  };

  inhalt.addEventListener('click', (e) => {
    const a = e.target.closest('a[data-galerie]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    if (!dialog) bauen();
    ausloeser = a;
    gruppe = links.filter((l) => l.dataset.galerie === a.dataset.galerie);
    zeigen(gruppe.indexOf(a));
    document.documentElement.classList.add('magazin-galerie-offen');
    dialog.showModal();
  });
})();
